var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2579_10877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 0C5.5975 0 0 5.5975 0 12.5C0 19.4025 5.5975 25 12.5001 25C19.4026 25 25.0001 19.4025 25.0001 12.5C25.0001 5.5975 19.4026 0 12.5001 0ZM8.86766 18.8965H5.82333V9.73759H8.86766V18.8965ZM7.34558 8.48695H7.32575C6.30417 8.48695 5.64347 7.78371 5.64347 6.9048C5.64347 6.00606 6.32439 5.32227 7.3658 5.32227C8.40722 5.32227 9.04808 6.00606 9.06793 6.9048C9.06793 7.78371 8.40722 8.48695 7.34558 8.48695ZM19.8449 18.8965H16.8009V13.9967C16.8009 12.7653 16.3601 11.9255 15.2586 11.9255C14.4177 11.9255 13.9168 12.492 13.6967 13.0388C13.6162 13.2346 13.5965 13.508 13.5965 13.7818V18.8965H10.5524C10.5524 18.8965 10.5922 10.5969 10.5524 9.73759H13.5965V11.0344C14.0011 10.4103 14.725 9.52264 16.3401 9.52264C18.343 9.52264 19.8449 10.8317 19.8449 13.6448V18.8965Z",
    fill: "#4AFEBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2579_10877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.249b88f7fbcd3be870c203fe597b817a.svg";
export { ForwardRef as ReactComponent };